export interface IMinerLog {
  readonly id: number; // miner hash || number
  readonly prev: string;
  readonly next: string;
}

export enum ActionTypesMinerChangeLogs {
  SET_MINER_LOGS = "SET_MINER_LOGS",
  CLEAR_MINER_LOGS = "CLEAR_MINER_LOGS",
  ADD_MINER_LOG = "ADD_MINER_LOG",
}

export interface ActionBaseMinerChangeLogs {
  readonly type: ActionTypesMinerChangeLogs;
}

export interface ActionSetMinerChangeLogs extends ActionBaseMinerChangeLogs {
  payload: IMinerLog[];
}

export interface ActionClearMinerChangeLogs extends ActionBaseMinerChangeLogs {}

export interface ActionAddMinerChangeLog extends ActionBaseMinerChangeLogs {
  payload: IMinerLog;
}
